import { Card, Divider, Flex } from 'antd'
import { useTheme } from 'antd-style'

import { InternalInventoryDocumentResponse2 } from 'src/api/requests'
import { Text } from 'src/components'
import { useStyles } from 'src/features/stock/components/inputs/styles'
import { useLocales } from 'src/locales'

type Props = {
  data?: InternalInventoryDocumentResponse2
}

export const LocalInputsCommentSection = ({ data }: Props) => {
  const { t } = useLocales()

  const palette = useTheme()

  const { styles } = useStyles()

  return (
    (data?.comment || data?.beneficiaryComment) && (
      <Card title={t('common.comment')} className={styles.commentCardWrapper}>
        {data?.comment && (
          <Flex vertical gap={8} className={styles.commentCard}>
            <Text size="lg">{t('stock.provider')}</Text>
            <div className={styles.commentBeneficiary}>{data?.comment}</div>
            <Text size="lg" color={palette.colorTextTertiary}>
              {data?.commentBy?.firstName} {data?.commentBy?.lastName} -{' '}
              {data?.role?.name}
            </Text>
          </Flex>
        )}

        {data?.beneficiaryComment && (
          <>
            <Divider className={styles.commentDivider} />
            <Flex vertical gap={8} className={styles.commentCard}>
              <Text size="lg">{t('stock_applications.beneficiary')}</Text>
              <div className={styles.commentBeneficiary}>
                {data?.beneficiaryComment}
              </div>
              <Text size="lg" color={palette.colorTextTertiary}>
                {data?.beneficiaryCommentBy?.firstName}{' '}
                {data?.beneficiaryCommentBy?.lastName}{' '}
                {data?.role ? ` - ${data?.role?.name}` : ''}
              </Text>
            </Flex>
          </>
        )}
      </Card>
    )
  )
}
